import { connect } from "react-redux";

import Energieverbrauch from "./Energieverbrauch";

import { compressorIsInstalled } from "../model/Kompressor";

const format_think_green_to_energy = (think_green, compressors) => {
	if (think_green.compressors === undefined)
		return [];

	let c_filtered = think_green.compressors.filter((c, i) => compressorIsInstalled(compressors[i]));
	let comp_ready = c_filtered.map(
		c => Object.assign({energy_total: c.energy_offload + c.energy_onload}, c)
	);
	let s = comp_ready.reduce((acc, curr) => {
		acc.energy_offload += curr.energy_offload;
		acc.energy_onload += curr.energy_onload;
		acc.energy_total += curr.energy_total;
		return acc;
	}, {cindex: -1, energy_offload: 0, energy_onload: 0, energy_total: 0});
	return [s].concat(comp_ready);
};

const format_energy_to_costs = (energy, units) => {
	if (energy === undefined)
		return [];

	return energy.map(e => {
		return {
			cindex: e.cindex,
			kosten_currency: e.energy_total * units.electricity_rate,
			co2_aequivalent_kg: e.energy_total * units.electricity_co2_equivalent
		};
	});
};

export default connect(state => {
	let energy = format_think_green_to_energy(state.ablauf.statistics.think_green, state.ablauf.compressors);
	let costs = format_energy_to_costs(energy, state.settings.units);
	return {
		energy,
		costs,
		compressors: state.ablauf.compressors,
		units: state.units
	};
})(Energieverbrauch);
